<se-fe-card>
  <se-fe-card-header seFeDataTitle="Media" seFeDataHeavyBorder="true">
    <div seFeCardHeaderActions>
      <item-media-modal
        class="item-detail-edit-modal item-detail-modal"
        id="edit-modal"
        [product]="product"
        [error]="error"
        [allowMultipleImages]="allowMultipleImages ?? false"
        (save)="onUpdateImage($event)"
        (uploadFailed)="onImageUploadFailed()"
        (uploadSucceeded)="onImageUploadSucceeded()"></item-media-modal>
    </div>
  </se-fe-card-header>
  <se-fe-card-content id="item-detail__product-media">
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell id="item-detail__image" seFeGridOpts>
        <!-- If there's more than one image, show the carousel -->
        @if (carouselContent.slides.length > 1) {
          <se-fe-carousel
            class="item-detail__image-carousel"
            [seFeDataContent]="carouselContent"
            [seFeDataConfig]="carouselConfig"
            (seFeSlideChange)="onCarouselSlideChange($event)">
            <ng-template let-slide seFeCarouselSlide>
              <img class="item-detail__image-frame" [src]="slide.src ?? ''" [alt]="slide.alt ?? ''" />
            </ng-template>
          </se-fe-carousel>
        } @else {
          <img class="item-detail__image-frame" [src]="image?.src ?? ''" [alt]="image?.alt ?? ''" />
        }
      </se-fe-grid-cell>
    </se-fe-grid>
    <se-fe-grid style="overflow: hidden" seFeGridOpts>
      <se-fe-grid-cell id="item-detail__image-text" seFeGridOpts>
        <se-fe-form-field [seFeDataConfig]="imageDescriptionLabel"></se-fe-form-field>
        <p>{{ currentImageForDescription?.alt }}</p>
      </se-fe-grid-cell>
    </se-fe-grid>
  </se-fe-card-content>
</se-fe-card>
